module.exports = __webpack_public_path__ + "static/media/gt.d765d2fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gt.png
// module id = 1869
// module chunks = 0